import { render, staticRenderFns } from "./catalog.vue?vue&type=template&id=558a7990&scoped=true&"
import script from "./catalog.vue?vue&type=script&lang=ts&"
export * from "./catalog.vue?vue&type=script&lang=ts&"
import style0 from "./catalog.vue?vue&type=style&index=0&id=558a7990&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558a7990",
  null
  
)

export default component.exports